// Chaque bloc "logo_item" (theme_service.BLOCK_TYPES["logo_list"]) est une
// image de logo — même principe de défilement que TechMarqueeSection, mais
// avec des images plutôt que du texte (marques partenaires, distributeurs...).
export default function LogoListSection({ blocks = [] }) {
  const items = (blocks || []).filter((b) => b.enabled !== false && b.type === "logo_item" && b.props?.image_url);
  if (!items.length) return null;

  return (
    <section className="border-y border-stone/80 overflow-hidden py-6 bg-white/40">
      <div className="flex w-max items-center lm-marquee">
        {[...items, ...items].map((b, i) => (
          <img
            key={`${b.id}-${i}`}
            src={b.props.image_url}
            alt={b.props.alt || ""}
            className="h-7 md:h-8 w-auto object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition mx-8 shrink-0"
          />
        ))}
      </div>
    </section>
  );
}
